export default {
  SEARCH_CATALOG_KUSPIT_FINANCIAL_INSTITUTIONS_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_FINANCIAL_INSTITUTIONS_QUERY'),
  CATALOG_KUSPIT_FINANCIAL_INSTITUTION_REPOSITORY: Symbol.for('CATALOG_KUSPIT_FINANCIAL_INSTITUTION_REPOSITORY'),
  CATALOG_KUSPIT_FINANCIAL_INSTITUTION_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_FINANCIAL_INSTITUTION_STATE_MANAGER'),
};
